<template>
<div class="chapter">
<div class="inner_page">
<h1 class="center" id="title_page">The Fat Woman’s Joke </h1>
<h2 class="center" style="margin-top:20px;">A Novel</h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 2title_page.vue?18c7b62a